import store from '@/store'
import {
  connectionService,
  RACE_TIMEOUT,
  TAG_RACE_TIMEOUT,
  TAG_CREATE_URI,
  TAG_FETCH_URI,
  TAG_FIND_URI,
  TAG_DELETE_URI,
  TAG_ENTITIES_FIND_URI,
  TAG_ENTITIES_ADD_URI,
  TAG_THING_SET_URI,
  TAG_AGENT_SET_URI,
  TAG_PERSON_SET_URI,
  TAG_UPDATE_URI
} from '@leapsight/styleguide'
import { i18n } from '@leapsight/portal'

export default {
  ENTITIE_TYPE: Object.freeze({
    THINGS: 'things',
    AGENTS: 'agents',
    PERSONS: 'persons'
  }),
  ACTION_TYPE: Object.freeze({
    TAG: 'tag',
    UNTAG: 'untag'
  }),
  sortTags(tagList) {
    return tagList.sort((a, b) => {
      const x = a.label.toUpperCase(),
        y = b.label.toUpperCase()
      return x == y ? 0 : x > y ? 1 : -1
    })
  },
  isTagsStoraged() {
    return new Promise((resolve, reject) => {
      try {
        const tagsData = localStorage.getItem('tags')?.length
        resolve(tagsData)
      } catch (e) {
        reject(e)
      }
    })
  },
  getTagsFromStorage() {
    return new Promise((resolve, reject) => {
      try {
        const tagsData = JSON.parse(localStorage.getItem('tags'))
        resolve(tagsData)
      } catch (e) {
        reject(e)
      }
    })
  },
  setTagsInLocalStorage(tags) {
    localStorage.setItem('tags', JSON.stringify(tags))
  },
  getTagsFind({ type = '' } = {}) {
    return new Promise((resolve, reject) => {
      const p1 = new Promise((resolve, reject) => {
        setTimeout(resolve, RACE_TIMEOUT, { error: 'timeout' })
      })
      const p2 = new Promise((resolve, reject) => {
        const connection = store.getters['auth/connection']
        const obj = {
          account_id: connectionService.getAccountId(),
          ...(!store.getters.isAdmin &&
            !store.getters.isAdminSubFleet && {
              user_id: connectionService.getBusinessUserId()
            }),
          ...(Boolean(type) && { type: type })
        }
        const args = [obj]
        const kwArgs = connectionService.createkwArgs()
        const options = {}
        kwArgs.query_spec = { _p: 'id,label,color' }

        connection.session.call(TAG_FIND_URI, args, kwArgs, options).then(
          response => {
            resolve(response)
          },
          wampError => {
            reject(wampError)
          }
        )
      })
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          resolve(error)
        })
    })
  },
  getTag(tagId) {
    return new Promise(resolve => {
      const p1 = new Promise((resolve, reject) => {
        setTimeout(resolve, RACE_TIMEOUT, { error: 'timeout' })
      })
      const p2 = new Promise((resolve, reject) => {
        const connection = store.getters['auth/connection']
        const args = [tagId]
        const kwArgs = connectionService.createkwArgs()
        const options = {}

        connection.session.call(TAG_FETCH_URI, args, kwArgs, options).then(
          response => {
            resolve(response)
          },
          wampError => {
            reject(wampError)
          }
        )
      })
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          resolve(error)
        })
    })
  },
  createTag(payload) {
    return new Promise((resolve, reject) => {
      const p1 = new Promise((resolve, reject) => {
        setTimeout(reject, RACE_TIMEOUT, { error: 'timeout' })
      })
      const p2 = new Promise((resolve, reject) => {
        const connection = store.getters['auth/connection']
        const accountId = connectionService.getAccountId()
        const args = [{ account_id: accountId, ...payload }]
        const kwArgs = connectionService.createkwArgs()
        const options = {}

        connection.session.call(TAG_CREATE_URI, args, kwArgs, options).then(
          response => {
            resolve(response)
          },
          wampError => {
            reject(wampError)
          }
        )
      })
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  prepareToStoreEntitiesTagByAction({
    tagId,
    entities,
    entityType,
    actionType
  }) {
    const formatEntities = {}
    entities.forEach(entity => {
      formatEntities[entity.id] = entity.label
    })
    return {
      action: actionType,
      tags: [tagId],
      [entityType]: formatEntities
    }
  },
  prepareToStoreEntities({ entities }) {
    const entitiesToStore = {}
    entities.forEach(entity => {
      entitiesToStore[entity.id] = entity.label
        ? entity.label
        : entity.info.label
    })
    return entitiesToStore
  },
  entitiesFind({ tagId, projection }) {
    return new Promise((resolve, reject) => {
      const p1 = new Promise((resolve, reject) => {
        setTimeout(reject, RACE_TIMEOUT, { error: 'timeout' })
      })
      const p2 = new Promise((resolve, reject) => {
        const connection = store.getters['auth/connection']
        const args = [tagId]
        const kwArgs = connectionService.createkwArgs()
        const options = {}
        kwArgs.query_match = { type: 'mrn:' + projection }
        kwArgs.query_spec = { _limit: 1000 }

        connection.session
          .call(TAG_ENTITIES_FIND_URI, args, kwArgs, options)
          .then(
            response => {
              resolve(response)
            },
            wampError => {
              reject(wampError)
            }
          )
      })
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  addEntitiesToTag({ tagId, entities }) {
    return new Promise((resolve, reject) => {
      const p1 = new Promise((resolve, reject) => {
        setTimeout(reject, TAG_RACE_TIMEOUT, { error: 'timeout' })
      })
      const p2 = new Promise((resolve, reject) => {
        const connection = store.getters['auth/connection']
        const args = [tagId, this.prepareToStoreEntities({ entities })]
        const kwArgs = connectionService.createkwArgs()
        const options = {
          timeout: TAG_RACE_TIMEOUT
        }

        connection.session
          .call(TAG_ENTITIES_ADD_URI, args, kwArgs, options)
          .then(
            response => {
              resolve(response)
            },
            wampError => {
              reject(wampError)
            }
          )
      })
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  setThingsToTag({ thingsAdded, thingsRemoved }) {
    return new Promise((resolve, reject) => {
      const connection = store.getters['auth/connection']
      const args = [
        [thingsAdded, thingsRemoved].filter(
          el => Boolean(el) && el.tags.length > 0
        )
      ]
      const kwArgs = connectionService.createkwArgs()
      const options = {
        timeout: TAG_RACE_TIMEOUT
      }

      const p1 = new Promise((resolve, reject) => {
        setTimeout(reject, TAG_RACE_TIMEOUT, [])
      })
      const p2 = new Promise((resolve, reject) => {
        connection.session.call(TAG_THING_SET_URI, args, kwArgs, options).then(
          response => {
            resolve(response)
          },
          wampError => {
            reject(wampError)
          }
        )
      })
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  setAgentsToTag({ agentsAdded, agentsRemoved }) {
    return new Promise((resolve, reject) => {
      const p1 = new Promise((resolve, reject) => {
        setTimeout(reject, TAG_RACE_TIMEOUT, { error: 'timeout' })
      })
      const p2 = new Promise((resolve, reject) => {
        const connection = store.getters['auth/connection']
        const args = [
          [agentsAdded, agentsRemoved].filter(
            el => Boolean(el) && el.tags.length > 0
          )
        ]
        const kwArgs = connectionService.createkwArgs()
        const options = {
          timeout: TAG_RACE_TIMEOUT
        }

        connection.session.call(TAG_AGENT_SET_URI, args, kwArgs, options).then(
          response => {
            resolve(response)
          },
          wampError => {
            reject(wampError)
          }
        )
      })
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  setPersonsToTag({ personsAdded, personsRemoved }) {
    return new Promise((resolve, reject) => {
      const p1 = new Promise(reject => {
        setTimeout(reject, TAG_RACE_TIMEOUT, { error: 'timeout' })
      })
      const p2 = new Promise((resolve, reject) => {
        const connection = store.getters['auth/connection']
        const args = [
          [personsAdded, personsRemoved].filter(
            el => Boolean(el) && el.tags.length > 0
          )
        ]
        const kwArgs = connectionService.createkwArgs()
        const options = {
          timeout: TAG_RACE_TIMEOUT
        }

        connection.session.call(TAG_PERSON_SET_URI, args, kwArgs, options).then(
          response => {
            resolve(response)
          },
          wampError => {
            reject(wampError)
          }
        )
      })
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateTag(payload) {
    return new Promise(resolve => {
      const p1 = new Promise((resolve, reject) => {
        setTimeout(resolve, RACE_TIMEOUT, { error: 'timeout' })
      })
      const p2 = new Promise((resolve, reject) => {
        const connection = store.getters['auth/connection']
        const args = [
          payload.id,
          { label: payload.label, color: payload.color }
        ]
        const kwArgs = connectionService.createkwArgs()
        const options = {}

        connection.session.call(TAG_UPDATE_URI, args, kwArgs, options).then(
          response => {
            resolve(response)
          },
          wampError => {
            reject(wampError)
          }
        )
      })
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          resolve(error)
        })
    })
  },
  deleteTag(tagId) {
    return new Promise(resolve => {
      const p1 = new Promise((resolve, reject) => {
        setTimeout(resolve, RACE_TIMEOUT, [])
      })
      const p2 = new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(this.deleteTagRace(tagId))
        }, 1000)
      })
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          resolve(error)
        })
    })
  },
  deleteTagRace(tagId) {
    return new Promise((resolve, reject) => {
      const connection = store.getters['auth/connection']
      const args = [tagId]
      const kwArgs = connectionService.createkwArgs()
      const options = {}
      const p1 = new Promise((resolve, reject) => {
        setTimeout(reject, RACE_TIMEOUT, { error: 'timeout' })
      })
      const p2 = new Promise((resolve, reject) => {
        connection.session.call(TAG_DELETE_URI, args, kwArgs, options).then(
          response => {
            resolve(response)
          },
          wampError => {
            reject(wampError)
          }
        )
      })
      Promise.race([p1, p2])
        .then(value => {
          resolve(value)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  //ERRORS
  getErrorMessageByCode(code) {
    let strToReturn
    switch (code) {
      case 'com.magenta.error.internal_error':
        strToReturn = i18n.t(
          'general.snackbarComponent.errors.default_error_msje'
        )
        break

      default:
        strToReturn = i18n.t(
          'general.snackbarComponent.errors.default_error_msje'
        )
        break
    }
    return strToReturn
  }
}
